'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.83 8.185 15 11.442v-.165c0-1.71-1.34-3.092-3-3.092h-.17Zm-4.3.824 1.55 1.598a2.92 2.92 0 0 0-.08.67c0 1.711 1.34 3.092 3 3.092.22 0 .44-.03.65-.082l1.55 1.598c-.67.34-1.41.546-2.2.546-2.76 0-5-2.309-5-5.154 0-.814.201-1.577.53-2.267v-.001ZM2 3.309l2.73 2.814A12.174 12.174 0 0 0 1 11.277c1.73 4.524 6 7.73 11 7.73 1.55 0 3.03-.31 4.38-.866l.43.433 2.92 3.01 1.27-1.31L3.27 2 2 3.31Zm10 2.814c2.76 0 5 2.309 5 5.154 0 .66-.13 1.298-.36 1.876l2.93 3.02A12.2 12.2 0 0 0 23 11.277c-1.73-4.525-6-7.73-11-7.73-1.4 0-2.74.257-4 .721l2.17 2.216c.57-.227 1.18-.36 1.83-.36v-.001Z",
    id: "eye-off_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#eye-off_svg__a"
  }));
});
var EyeOff = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.EyeOff = EyeOff;